import { IdentityPageTranslations } from '../types';

export const translations: IdentityPageTranslations = {
  docTitle: 'Identity Restoration',
  pageTitle: 'Identity Restoration',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'Received an alert? We can help.',
      summary: [
        '<p>If your information has been found on a suspicious website, or you have received a credit bureau inquiry',
        'that you do not recognize, you may have become a victim of identity theft. Contact our identity restoration',
        'specialists to help confirm whether you have been victimized.</p>',
        '<p class="text-contact-number"><span class="sr-only">Phone number:</span>',
        '<a href="tel:+1-866-327-3078" class="text-nowrap">1-866-327-3078</a></p>',
        '<p>If you have become a victim of identity theft, our identity restoration specialists can help save you time,',
        'money and stress by helping you take the necessary steps to report fraudulent activity and get your identity',
        'restored.</p>'
      ].join('\n')
    },
    {
      key: '1',
      heading: '',
      summary: [
        '<p>Choose from three tiers of service to ensure you get the assistance that suits your needs.</p>',
        '<h2 class="feature-item-heading">General Assistance</h2>',
        '<p>Arm yourself the resources and tips you need to help prevent your identity from being stolen.</p>',
        '<h2 class="feature-item-heading">Guided Restoration</h2>',
        '<p>We’ll pair you with a dedicated Fraud investigator to confirm your identity was stolen, complete',
        'all the paperwork, and follow up throughout the process.</p>',
        '<h2 class="feature-item-heading">Limited Power of Attorney</h2>',
        '<p>We’ll work directly with creditors, government offices and other agencies on your behalf',
        '(if you sign a power of attorney).</p>'
      ].join('\n')
    }
  ]
};
